/**
 * This file contains constants that are used across the component library
 */
/**
 *  This is the map of component size to body text size (visualAppearance)
 */
export var componentSizeToBodyTextSizeMap = {
    l: 'body-one',
    m: 'body-two',
    s: 'body-three',
    xs: 'body-four',
};
